export const DEFAULT_TOOL_PROPERTIES = {
  new0: {
    type: 'string',
  },
};
